import React from "react"

import { InputDigits } from "@atos6/components"
import { digitsOnly } from "@atos6/utils"
import { useStore } from "../containers"

export function InputAccountDigitStateful() {
  const { accountDigit, setState } = useStore()

  return (
    <InputDigits
      placeholder="Dígito"
      maxLength={1}
      value={digitsOnly(accountDigit)}
      onChange={accountDigit => setState({ accountDigit })}
    />
  )
}
